<template>
  <div class="join-pursuits">
    <span class="join-pursuits__title">Join the Pursuit</span>
    <div class="join-pursuits__content">
      <div class="join-pursuits__item" v-for="item in items" :key="item.id">
        <img :src="item.icon" :alt="item.title" class="join-pursuits__item__icon" />
        <div class="join-pursuits__item__content">
          <h3 class="join-pursuits__item__title">{{ item.title }}</h3>
          <p class="join-pursuits__item__description">{{ item.description }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "JoinPursuits",
  data() {
    return {
      items: [
        {
          id: 1,
          title: "Expert-led movement",
          description: "Train, explore, and recover with trusted experience providers and industry professionals.",
          icon: require('@/assets/icons/running.png'),
        },
        {
          id: 2,
          title: "On-the-ground community",
          description: "Connect with local communities, learn new skills, and engage in sustainable exploration one trail at a time.",
          icon: require('@/assets/icons/plant.png'),
        },
        {
          id: 3,
          title: "Life in motion",
          description: "Discover the joy of purposeful movement, active wellness, and everyday play.",
          icon: require('@/assets/icons/body-language.png'),
        },
      ]
    }
  },
  methods: {
  }
}
</script>
<style scoped lang="scss">
.join-pursuits {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding-inline: 20px;
  margin-bottom: 40px;
  &__content {
    width: 100%;
    flex-direction: column;
    gap: 20px;
    display: flex;
  }
  &__item {
    display: flex;
    align-items: flex-start;
    gap: 20px;
    &__icon {
      min-width: 60px;
      max-width: 60px;
      aspect-ratio: 1/1;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &__content {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }
    &__title {
      text-align: left;
      font-family: 'Berthold Akzidenz Grotesk Medium';
      display: block;
    }
    &__description {
      font-size: 16px;
      line-height: 22px;
      text-align: left;
      display: block;
    }
  }
  &__title {
    text-align: left;
    font-family: 'Berthold Akzidenz Grotesk Medium';
    font-size: 2em;
    color: $blue-head;
    margin-bottom: 40px;
    display: block;
  }
  &__description {
    font-size: 16px;
    margin-bottom: 10px;
    display: block;
    text-align: left;
  }
  &__button {
    display: inline-block;
    margin-top: 20px;
    padding: 10px 20px;
    background-color: #007bff;
    color: #fff;
    text-decoration: none;
    border-radius: 4px;

    &:hover {
      background-color: #0056b3;
    }
  }
}
@media (min-width: 672px) {
  .join-pursuits {
    &__content {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(30%, 1fr));
      gap: 20px;
    }
    &__item {
      &__description {
        max-width: 300px;
      }
    }
  }
}
@media (min-width: 672px) and (max-width: 1024px) {
  .join-pursuits {
    &__content {
      grid-template-columns: repeat(auto-fill, minmax(40%, 1fr)) !important;
    }
    &__item {
      &__description {
        max-width: 100% !important;
      }
    }
  }
}
</style>